/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resources_DescriptionInputs */

const en_blog_resources_description = /** @type {(inputs: Blog_Resources_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the live Seek AI resources below for product discovery, submissions, and integrations.`)
};

const zh_blog_resources_description = /** @type {(inputs: Blog_Resources_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Seek AI 当前可用的产品发现、提交和集成资源。`)
};

/**
* | output |
* | --- |
* | "Use the live Seek AI resources below for product discovery, submissions, and integrations." |
*
* @param {Blog_Resources_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resources_description = /** @type {((inputs?: Blog_Resources_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resources_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resources_description(inputs)
	return zh_blog_resources_description(inputs)
});
export { blog_resources_description as "blog.resources_description" }